import React, { useCallback, useEffect, useState } from 'react'
import { Loader } from 'src/components/shared/Loader'
import { cacheWebImages } from '../utils/cacheHelper'
import boothPdf from '../images/booth/Brochure.png'
import boothViewer from '../images/booth/Poster.png'
import boothVideo from '../images/booth/Video.png'
import boothChat from '../images/booth/Chat.png'

export const fixedAssets = {
  regBg: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/bg.jpg",
  regBgM: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/bgM.jpg",
  kvTitle: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/kv_title_updated.png",
  kvTitleM: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/kv_titleM_updated.png",
  growth: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/growth.png",
  cognition: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/cognition.png",
  comfort: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/comfort.png",
  rock: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/spacerock.png",
  formBg: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/login-form.png",
  entranceBg: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/space-bg.png",
  nicknameBg: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/nickname_form.png",
  lobby: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/lobby-bg.jpg",
  rotateCircle: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/circle_visual.png",
  cognitionBright: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Cognition-icon.png",
  comfortBright: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Comfort-icon.png",
  growthBright: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Growth-icon.png",
  top: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/topLayer.png",
  bottom: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/bottomLayer.png",
  upArrow: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/upArrow.png",
  homeNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/homeNav.png",
  agendaNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/agendaNav.png",
  programmeNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/programmeNav.png",
  auditoriumNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/auditoriumNav.png",
  boothNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/boothNav.png",
  logoutNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/logoutNav.png",
  helpdeskNav: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/helpdeskNav.png",
  objective: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/PAED-Objective.jpg",
  day1: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/PAED-DAY-1.jpg",
  day2: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/PAED-DAY-2.jpg",
  slide1: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide1.JPG",
  slide2: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide2.JPG",
  slide3: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide3.JPG",
  slide4: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide4.JPG",
  slide5: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide5.JPG",
  slide6: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide6.JPG",
  slide7: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide7.JPG",
  slide8: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide8.JPG",
  slide9: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide9.JPG",
  slide10: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/Speakers/Slide10.JPG",
  boothBg: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/booth-bg.jpg",
  boothBase: "https://abbott-ce-assets.s3.ap-southeast-1.amazonaws.com/booth-base.png",
  boothVideo,
  boothPdf,
  boothViewer,
  boothChat
}

export const PreCache = ({ deviceType, children }) => {
  const [pageLoading, setPageLoading] = useState(false)

  const preloadAssets = useCallback(async () => {
    setPageLoading(true)
    await cacheWebImages(Object.values(fixedAssets))
    setPageLoading(false)
  }, [])

  useEffect(() => {
    preloadAssets()
  }, [deviceType, preloadAssets])

  return (
    <Loader loading={pageLoading} fullPage>
      <>{children}</>
    </Loader>
  )
}
